export default "__VITE_ASSET__B4IE411N__"